import request from '@/utils/srdRequest';

const getDate = () => {
    let now = new Date(),
      y = now.getFullYear(),
      m = now.getMonth() + 1,
      d = now.getDate();
    return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
  }

const logReport = obj => {
  // console.log(process.env.VUE_APP_SRD_SERVER_API)
  Object.assign(obj, {
    platform: 'web',
    app_name: 'ysh',
    time: Date.parse(new Date()),
    date: getDate()
  })
  request({
    url: '/api/sls/behavior-log',
    method: 'put',
    data: [obj]
  })
}


export function sendPageLog(obj) {
  Object.assign(obj, { event: 'EnterPage' })
  logReport(obj)
}

export function sendClickLog(obj) {
  Object.assign(obj, { event: 'Click' })
  logReport(obj)
}
